// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__11wHT","row":"styles_row__Fa5z8"};